@if (user$ | async; as user) {
  <fo-toolbar [title]="user.firstName + ' ' + user.lastName">
    <ng-container leftElements>
      <fo-breadcrumb></fo-breadcrumb>
    </ng-container>
    <ng-container rightElements>
      <fo-action-buttons [actionButtons]="actions"></fo-action-buttons>
    </ng-container>
  </fo-toolbar>
}

<div class="container">
  <mat-form-field class="d-block" appearance="outline">
    <mat-label>{{ 'forms:search' | i18nextCap }}</mat-label>
    <input matInput [formControl]="partSearchCtrl" autocomplete="off" />
  </mat-form-field>

  @if (filteredParts$ | async; as filteredParts) {
    <ul>
      @if (user$ | async; as user) {
        <div mat-dialog-title>
          {{ user.firstName }} {{ user.lastName }}
          {{ 'collection' | i18nextCap }}
        </div>
      }
      <mat-divider></mat-divider>
      @for (userPart of filteredParts[1]; track userPart) {
        <li class="light-green-50">
          <button
            mat-button
            type="button"
            color="warn"
            (click)="onRemovePart(userPart)"
          >
            {{ 'remove' | i18nextCap }}
          </button>
          <span>{{ userPart.part.name }}</span>
          <div class="quantity">
            <label>{{ 'quantity' | i18nextCap }}</label>
            <input
              mat-input
              type="number"
              min="0"
              step="1"
              [value]="userPart.quantity"
              (change)="onChangeQuantity($event, userPart)"
            />
          </div>
        </li>
      }
      @if (!filteredParts[1].length) {
        <crm-empty-warn
          message="{{ 'error:noUserPartsMatchTheSearch' | i18nextCap }} '{{
            partSearchCtrl.value
          }}'"
        ></crm-empty-warn>
      }
      <div mat-dialog-title>Tenant {{ 'collection' | i18nextCap }}</div>
      <mat-divider></mat-divider>
      @for (part of filteredParts[0]; track part) {
        <li>
          <button
            mat-button
            type="button"
            color="primary"
            (click)="onAddPart(part)"
          >
            {{ 'add' | i18nextCap }}
          </button>
          {{ part.name }}
        </li>
      }
      @if (!filteredParts[1].length) {
        <crm-empty-warn
          message="{{ 'error:noTenantPartsMatchTheSearch' | i18nextCap }} '{{
            partSearchCtrl.value
          }}'"
        ></crm-empty-warn>
      }
    </ul>
  }
</div>
